var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0332 15.525L7.17947 12.6328C7.00514 12.4519 6.91797 12.241 6.91797 12C6.91797 11.759 7.00514 11.5481 7.17947 11.3672L10.0332 8.475C10.1807 8.32117 10.3465 8.28258 10.5305 8.35925C10.7145 8.43592 10.8065 8.58158 10.8065 8.79625V15.2135C10.8065 15.4243 10.7145 15.5674 10.5305 15.6427C10.3465 15.7181 10.1807 15.6788 10.0332 15.525ZM12.9987 19.75V4.25C12.9987 4.0375 13.0706 3.85942 13.2145 3.71575C13.3583 3.57192 13.5365 3.5 13.749 3.5C13.9616 3.5 14.1397 3.57192 14.2832 3.71575C14.4269 3.85942 14.4987 4.0375 14.4987 4.25V19.75C14.4987 19.9625 14.4268 20.1406 14.283 20.2843C14.1391 20.4281 13.961 20.5 13.7485 20.5C13.5358 20.5 13.3577 20.4281 13.2142 20.2843C13.0706 20.1406 12.9987 19.9625 12.9987 19.75Z",
    fill: "#1819B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/ArrowLeftIcon.aeabf3b493bc6f5a6c5254a510979eec.svg";
export { ForwardRef as ReactComponent };